import React, { useEffect, useState } from "react";
import { db } from "../service/firebase";

function Slides() {
  const [slideImg, setSlideImg] = useState({});
  useEffect(() => {
    db.collection("slides")
      .doc("slide")
      .get()
      .then((doc) => {
        setSlideImg(doc.data());
      });
  }, []);
  return (
    <div className="slides p-1">
      <div
        id="carouselExampleIndicators"
        className="carousel slide"
        data-ride="carousel"
      >
        <ol className="carousel-indicators">
          <li
            data-target="#carouselExampleIndicators"
            data-slide-to="0"
            className="active"
          ></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        </ol>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src={slideImg.img1} className="d-block w-100" alt="..."></img>
          </div>
          <div className="carousel-item">
            <img src={slideImg.img2} className="d-block w-100" alt="..."></img>
          </div>
        </div>
        <a
          className="carousel-control-prev"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="sr-only">Previous</span>
        </a>
        <a
          className="carousel-control-next"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="sr-only">Next</span>
        </a>
      </div>
    </div>
  );
}

export default Slides;
